module.exports = __webpack_public_path__ + "static/media/34679add-f337-4ef7-aacc-7d22b582e6a1.6dfdea5f.webp";